import React, { useEffect } from 'react';
import NavbarAdmin from '../../../Components/AdminComp/sidebarAdmin.js';
import './HomePageAdmin.css';
import Logo from './assets/logo.png';

const HomePageAdmin = () => {
  // Préchargement de l'image pour de meilleures performances
  useEffect(() => {
    const img = new Image();
    img.src = Logo;
  }, []);

  return (
    <div className="admin-main-container">
  <NavbarAdmin /> {/* ta sidebar */}
  <div className='homePageAdmin'>
    <div className="admin-content-wrapper">
      <h2 className="admin-title">HOTEL SYPHAX</h2>
      <p className="admin-subtitle">L'excellence d'un hôtel réside dans sa gestion !</p>
      <div className="admin-image-container">
        <img 
          src={Logo} 
          alt='Logo Hotel Syphax' 
          className="admin-logo"
          loading="lazy"
        />
      </div>
    </div>
  </div>
</div>

  );
};

export default React.memo(HomePageAdmin);